var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:(_vm.style)},[_c('table',[_c('tbody',[_c('tr',[(!_vm.hasImage)?_c('td',[_vm._v(_vm._s(_vm.initials))]):_vm._e()])])])])}
var staticRenderFns = []

export { render, staticRenderFns }